import _ from 'underscore';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  RecommendationService,
  CHANNEL_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import featureInstrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import pageContext from '@bingads-webui-static-legacy/page-context';
import config from '@bingads-webui-component-legacy/config/index';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

const RECOMMENDATION_SUMMARY_TOP_NUMBER = 5;
const permissions = config.get('Permissions') || {};
const schema = {
  scenario: [
    {
      name: 'loadRecommendationTile',
      value: 'LoadRecommendationTab',
      setting: {},
      activity: [
        {
          name: 'loadRecommendationTile',
          value: 'LoadRecommendationTile',
        },
        {
          name: 'getSummary',
          value: 'getSummary',
        },
        {
          name: 'getCoupons',
          value: 'getCoupons',
        },
      ],
    },
  ],
};

export const WithOptimizationScoreRepository = ({
  WrappedComponent, scope, ...passThroughProps
}) => {
  const [osData, setOsData] = useState({});
  const {
    aid, campaignId, cid, adGroupId,
  } = scope.values;
  const { campaignFromOData } = passThroughProps;
  const campaignType = campaignFromOData ? campaignFromOData.CampaignType : 'Default';

  useEffect(() => {
    if (!campaignId || adGroupId) {
      return;
    }

    featureInstrumentation.addScenario(schema);
    const currentScenario = featureInstrumentation.loadRecommendationTile.create();
    const currentActivity = currentScenario.loadRecommendationTile.create();

    const dataService = new RecommendationService({
      scope: {
        customerId: cid,
        accountId: aid,
        campaignId,
        campaignName: _.result(config.get('CurrentCampaign'), 'Name'),
        token: config.get('Token'),
        levelAt: levelAtConstant.CAMPAIGN,
        entityIds: [campaignId],
      },
      currentScenario,
      currentActivity,
      odataPath: config.get('adinsight.odata.url'),
      permissions,
      lcid: pageContext.CultureLcid,
      isNoExpand: true,
      channel: CHANNEL_TYPES.CAMPAIGN_SUMMARY_BAR,
    });

    dataService.getSummary({
      channel: CHANNEL_TYPES.CAMPAIGN_SUMMARY_BAR,
      campaignType,
      top: RECOMMENDATION_SUMMARY_TOP_NUMBER,
      ignoreCoupons: true,
    }).then((response) => {
      const { data } = response;

      setOsData(data);
    });
  }, [adGroupId, aid, campaignId, campaignType, cid]);

  return (<WrappedComponent osData={osData} {...passThroughProps} />);
};

WithOptimizationScoreRepository.propTypes = {
  WrappedComponent: PropTypes.func.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
};
